
// import React from "react";
// import { useForm } from "react-hook-form";
// import { yupResolver } from "@hookform/resolvers/yup";
// import * as yup from "yup";
// import "bootstrap/dist/css/bootstrap.min.css";

// // const schema = yup.object().shape({
// //   fullName: yup.string().min(3, "Too short").required("Full Name is required"),
// //   phone: yup.string().matches(/^[0-9]{10}$/, "Phone number must be 10 digits").required("Phone number is required"),
// //   email: yup.string().email("Invalid email").required("Email is required"),
// //   dateOfJourney: yup.date().min(new Date(), "Date must be in the future").required("Date is required"),
// //   source: yup.string().required("Source is required"),
// //   destination: yup.string().required("Destination is required"),
// //   trip: yup.string().required("Trip type is required"),
// //   adults: yup.number().min(1, "At least one adult required").required(),
// //   children: yup.number().min(0).required(),
// // });

// const schema = yup.object().shape({
//   fullName: yup.string().min(3, "Too short").required("Full Name is required"),
//   phone: yup
//     .string()
//     .matches(/^[0-9]{10}$/, "Phone number must be exactly 10 digits and contain only numbers")
//     .required("Phone number is required"),
//   email: yup.string().email("Invalid email").required("Email is required"),
//   dateOfJourney: yup
//     .date()
//     .typeError("Invalid date format")
//     .min(new Date(), "Date must be in the future")
//     .required("Date is required"),
//   source: yup.string().required("Source is required"),
//   destination: yup.string().required("Destination is required"),
//   trip: yup.string().required("Trip type is required"),
//   adults: yup
//     .number()
//     .typeError("Adults must be a valid number")
//     .integer("Adults must be a whole number")
//     .min(1, "At least one adult required")
//     .required("Number of adults is required"),
//   children: yup
//     .number()
//     .typeError("Children must be a valid number")
//     .integer("Children must be a whole number")
//     .min(0, "Children cannot be negative")
//     .required("Number of children is required"),
// });



// const GOOGLE_SHEET_URL = "https://script.google.com/macros/s/AKfycby0NiG3mcmDKmltPQBkzprlDruF7wxNbhGdaSc97ER9nG1z7Mc0PRsyh_vyePtTV9LH/exec";

// const BookingForm = ({ onClose }) => {
//   const {
//     register,
//     handleSubmit,
//     formState: { errors },
//   } = useForm({
//     resolver: yupResolver(schema),
//     defaultValues: { adults: 1, children: 0 },
//   });

//   const handleModalClose = () => {
//     console.log("Closing Modal...");
//     onClose(); // Close modal
//   };

//   const onSubmit = async (data) => {
//     try {
//       console.log("Sending Data:", data);
//       const response = await fetch(GOOGLE_SHEET_URL, {
//         method: "POST",
//         headers: { "Content-Type": "application/x-www-form-urlencoded" },
//         body: new URLSearchParams(data).toString(),
//       });
//       const result = await response.json();
//       console.log("Response:", result);

//       if (result.result === "success") {
//         alert("Form submitted successfully!");
//         handleModalClose();
//       } else {
//         alert("Error: " + result.error);
//       }
//     } catch (error) {
//       console.error("Error submitting form:", error);
//       alert("Failed to submit form.");
//     }
//   };

//   return (
//     <div
//       className="modal fade show d-flex align-items-center justify-content-center"
//       tabIndex="-1"
//       style={{
//         backgroundColor: "rgba(0, 0, 0, 0.6)",
//         position: "fixed",
//         top: 0,
//         left: 0,
//         width: "100%",
//         height: "100vh",
//       }}
//       onClick={handleModalClose} // Click outside closes modal
//     >
//       <div
//         className="modal-dialog modal-lg"
//         onClick={(e) => e.stopPropagation()} // Prevents closing when clicking inside modal
//       >
//         <div className="modal-content p-3 rounded shadow-lg">
//           <div className="modal-header bg-primary text-white">
//             <h5 className="modal-title">Travel Booking Form</h5>
//             <button type="button" className="btn-close" onClick={handleModalClose}></button>
//           </div>
//           <div className="modal-body">
//             <form onSubmit={handleSubmit(onSubmit)}>
//               <div className="row g-3">
//                 <div className="col-md-6">
//                   <label className="form-label">Full Name</label>
//                   <input className="form-control" {...register("fullName")} />
//                   <small className="text-danger">{errors.fullName?.message}</small>
//                 </div>
//                 <div className="col-md-6">
//                   <label className="form-label">Phone Number</label>
//                   <input className="form-control" {...register("phone")} />
//                   <small className="text-danger">{errors.phone?.message}</small>
//                 </div>
//                 <div className="col-md-6">
//                   <label className="form-label">Email</label>
//                   <input className="form-control" {...register("email")} />
//                   <small className="text-danger">{errors.email?.message}</small>
//                 </div>
//                 <div className="col-md-6">
//                   <label className="form-label">Date of Journey</label>
//                   <input type="date" className="form-control" {...register("dateOfJourney")} />
//                   <small className="text-danger">{errors.dateOfJourney?.message}</small>
//                 </div>
//                 <div className="col-md-6">
//                   <label className="form-label">Source</label>
//                   <select className="form-control" {...register("source")}>
//                     <option value="">Select Source</option>
//                     <option value="City A">City A</option>
//                     <option value="City B">City B</option>
//                   </select>
//                   <small className="text-danger">{errors.source?.message}</small>
//                 </div>
//                 <div className="col-md-6">
//                   <label className="form-label">Destination</label>
//                   <select className="form-control" {...register("destination")}>
//                     <option value="">Select Destination</option>
//                     <option value="City X">City X</option>
//                     <option value="City Y">City Y</option>
//                   </select>
//                   <small className="text-danger">{errors.destination?.message}</small>
//                 </div>
//                 <div className="col-md-6">
//                   <label className="form-label">Trip Type</label>
//                   <select className="form-control" {...register("trip")}>
//                     <option value="">Select Trip</option>
//                     <option value="One Way">One Way</option>
//                     <option value="Round Trip">Round Trip</option>
//                   </select>
//                   <small className="text-danger">{errors.trip?.message}</small>
//                 </div>
//                 <div className="col-md-3">
//                   <label className="form-label">Adults</label>
//                   <input type="number" className="form-control" {...register("adults")} min="1" />
//                 </div>
//                 <div className="col-md-3">
//                   <label className="form-label">Children</label>
//                   <input type="number" className="form-control" {...register("children")} min="0" />
//                 </div>
//               </div>
//               <div className="d-flex justify-content-between mt-4">
//                 <button type="submit" className="btn btn-success px-4">Submit</button>
//                 <button type="button" className="btn btn-danger px-4" onClick={handleModalClose}>Close</button>
//               </div>
//             </form>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default BookingForm;




import React from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import emailjs from "@emailjs/browser";
import "bootstrap/dist/css/bootstrap.min.css";

// const schema = yup.object().shape({
//   fullName: yup.string().min(3, "Too short").required("Full Name is required"),
//   phone: yup.string().matches(/^[0-9]{10}$/, "Phone number must be 10 digits").required("Phone number is required"),
//   email: yup.string().email("Invalid email").required("Email is required"),
//   dateOfJourney: yup.date().min(new Date(), "Date must be in the future").required("Date is required"),
//   source: yup.string().required("Source is required"),
//   destination: yup.string().required("Destination is required"),
//   trip: yup.string().required("Trip type is required"),
//   adults: yup.number().min(1, "At least one adult required").required(),
//   children: yup.number().min(0).required(),
// });

const schema = yup.object().shape({
  fullName: yup.string().min(3, "Too short").required("Full Name is required"),
  phone: yup
    .string()
    .matches(/^[0-9]{10}$/, "Phone number must be exactly 10 digits and contain only numbers")
    .required("Phone number is required"),
  email: yup.string().email("Invalid email").required("Email is required"),
  dateOfJourney: yup
    .date()
    .typeError("Invalid date format")
    .min(new Date(), "Date must be in the future")
    .required("Date is required"),
  source: yup.string().required("Source is required"),
  destination: yup.string().required("Destination is required"),
  trip: yup.string().required("Trip type is required"),
  adults: yup
    .number()
    .typeError("Adults must be a valid number")
    .integer("Adults must be a whole number")
    .min(1, "At least one adult required")
    .required("Number of adults is required"),
  children: yup
    .number()
    .typeError("Children must be a valid number")
    .integer("Children must be a whole number")
    .min(0, "Children cannot be negative")
    .required("Number of children is required"),
});



const GOOGLE_SHEET_URL = "https://script.google.com/macros/s/AKfycby0NiG3mcmDKmltPQBkzprlDruF7wxNbhGdaSc97ER9nG1z7Mc0PRsyh_vyePtTV9LH/exec";

const BookingForm = ({ onClose }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: { adults: 1, children: 0 },
  });

  const handleModalClose = () => {
    console.log("Closing Modal...");
    onClose(); // Close modal
  };


  const onSubmit = async (data) => {
    try {
      console.log("Sending Data:", data);
  
      // Sending data to Google Sheets
      const response = await fetch(GOOGLE_SHEET_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(data).toString(),
      });
  
      const result = await response.json();
      console.log("Google Sheets Response:", result);
  
      // If Google Sheets submission is successful, send email
      if (result.result === "success") {
        const emailResponse = await emailjs.send(
          "service_6cvgbal",  // Replace with your EmailJS Service ID
          "template_srnyza7", // Replace with your EmailJS Template ID
          {
            fullName: data.fullName,
            phone: data.phone,
            email: data.email,
            dateOfJourney: data.dateOfJourney,
            source: data.source,
            destination: data.destination,
            trip: data.trip,
            adults: data.adults,
            children: data.children,
          },
          "_xyrSV8unWRyjvI89" // Replace with your EmailJS Public Key
        );
  
        console.log("Email Sent:", emailResponse);
        alert("Form submitted successfully and email sent!");
        handleModalClose();
      } else {
        alert("Error submitting form to Google Sheets: " + result.error);
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Failed to submit form or send email.");
    }
  };

  return (
    <div
      className="modal fade show d-flex align-items-center justify-content-center"
      tabIndex="-1"
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.6)",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100vh",
      }}
      onClick={handleModalClose} // Click outside closes modal
    >
      <div
        className="modal-dialog modal-lg"
        onClick={(e) => e.stopPropagation()} // Prevents closing when clicking inside modal
      >
        <div className="modal-content p-3 rounded shadow-lg">
          <div className="modal-header bg-primary text-white">
            <h5 className="modal-title">Travel Booking Form</h5>
            <button type="button" className="btn-close" onClick={handleModalClose}></button>
          </div>
          <div className="modal-body">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="row g-3">
                <div className="col-md-6">
                  <label className="form-label">Full Name</label>
                  <input className="form-control" {...register("fullName")} />
                  <small className="text-danger">{errors.fullName?.message}</small>
                </div>
                <div className="col-md-6">
                  <label className="form-label">Phone Number</label>
                  <input className="form-control" {...register("phone")} />
                  <small className="text-danger">{errors.phone?.message}</small>
                </div>
                <div className="col-md-6">
                  <label className="form-label">Email</label>
                  <input className="form-control" {...register("email")} />
                  <small className="text-danger">{errors.email?.message}</small>
                </div>
                <div className="col-md-6">
                  <label className="form-label">Date of Journey</label>
                  <input type="date" className="form-control" {...register("dateOfJourney")} />
                  <small className="text-danger">{errors.dateOfJourney?.message}</small>
                </div>
                <div className="col-md-6">
                  <label className="form-label">Source</label>
                  <select className="form-control" {...register("source")}>
                    <option value="">Select Source</option>
                    <option value="New York">New York</option>
                    <option value="Los Angeles">Los Angeles</option>
                    <option value="Chicago">Chicago</option>
                    <option value="Houston">Houston</option>
                    <option value="San Francisco">San Francisco</option>
                  </select>
                  <small className="text-danger">{errors.source?.message}</small>
                </div>
                <div className="col-md-6">
                  <label className="form-label">Destination</label>
                  <select className="form-control" {...register("destination")}>
                  <option value="">Select Destination</option>
                    <option value="Miami">Miami</option>
                    <option value="Seattle">Seattle</option>
                    <option value="Dallas">Dallas</option>
                    <option value="Atlanta">Atlanta</option>
                    <option value="Boston">Boston</option>
                  </select>
                  <small className="text-danger">{errors.destination?.message}</small>
                </div>
                <div className="col-md-6">
                  <label className="form-label">Trip Type</label>
                  <select className="form-control" {...register("trip")}>
                    <option value="">Select Trip</option>
                    <option value="One Way">One Way</option>
                    <option value="Round Trip">Round Trip</option>
                  </select>
                  <small className="text-danger">{errors.trip?.message}</small>
                </div>
                <div className="col-md-3">
                  <label className="form-label">Adults</label>
                  <input type="number" className="form-control" {...register("adults")} min="1" />
                </div>
                <div className="col-md-3">
                  <label className="form-label">Children</label>
                  <input type="number" className="form-control" {...register("children")} min="0" />
                </div>
              </div>
              <div className="d-flex justify-content-between mt-4">
                <button type="submit" className="btn btn-success px-4">Submit</button>
                <button type="button" className="btn btn-danger px-4" onClick={handleModalClose}>Close</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookingForm;

